import { extendTheme } from '@chakra-ui/react';

export const dark = extendTheme({
  colors: {
    gray: {
      '900': '#181B23',
      '800': '#1F2029',
      '750': '#253646',
      '700': '#353646',
      '650': '#6c757d',
      '600': '#4B4D63',
      '500': '#616480',
      '400': '#797D9A',
      '300': '#9699B0',
      '200': '#B3B5C6',
      '100': '#4B4D63',
      '50': '#EEEEF2',
    },
    yellow: {
      '500': '#f2c811',
    },
    white: {
      '100': '#F8F8FB',
      '50': '#fff',
    },
  },

  fonts: {
    heading: 'Roboto',
    body: 'Roboto',
  },

  components: {
    // O Tooltip do Chakra v1 aplica bg/color a partir do styleConfig do tema
    // (useStyleConfig("Tooltip")). Definimos aqui o contraste (fundo escuro /
    // texto claro) para todos os tooltips do app. O bg também pinta a setinha.
    Tooltip: {
      baseStyle: {
        bg: '#1e293b',
        color: '#f8fafc',
        '--popper-arrow-bg': '#1e293b',
        borderRadius: 'md',
        fontSize: 'xs',
        px: 3,
        py: 1.5,
      },
    },
  },

  styles: {
    global: {
      body: {
        bg: 'gray.900',
        color: 'gray.50',
        transition: '1s',
        webkitFontSmoothing: 'antialiased',

        '.search': {
          background: 'gray.200',
          color: 'gray.900',
        },
        '.select-item': {
          background: 'gray.600',
          color: 'gray.50',
        },
        '.select-item :hover': {
          color: 'gray.650',
        },

        h1: {
          fontWeight: '500',
          fontSize: '24px',
        },
        h2: {
          fontWeight: '500',
        },
        h3: {
          fontWeight: '500',
        },
        h4: {
          fontWeight: '500',
        },
        h5: {
          fontWeight: '500',
        },
        h6: {
          fontWeight: '500',
        },
        strong: {
          fontWeight: '500',
        },
        select: {
          fontWeight: '500',
        },
      },
    },
  },
});
